import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientEligibilityComponent } from './patient-eligibility.component';
import { TranslateModule } from '@ngx-translate/core';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

@NgModule({
  declarations: [
    PatientEligibilityComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    DialogsModule,
    ButtonsModule
  ],
  exports: [
    PatientEligibilityComponent
  ]
})
export class PatientEligibilityModule { }
